import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer
      style={{
        padding: 12,
        textAlign: "center",
        background: "#e6e6e6"
      }}
    >
      <div style={{ marginBottom: 8 }}>
        <Link to="/privacy" style={{ marginRight: 15 }}>
          {t("footer.privacy")}
        </Link>

        <Link to="/terms">
          {t("footer.terms")}
        </Link>
      </div>

      <small>© {new Date().getFullYear()} VIPart.ge</small>
    </footer>
  );
}
